import React, { createContext, useContext, useState, useCallback, useEffect } from "react";

const GeofenceContext = createContext({
	// sensible defaults (won’t be used when wrapped by Provider)
	geofenceDeleted: false,
	setGeofenceDeleted: () => {},
	initialData: null,
	setInitialData: () => {},
	fenceData: null,
	setFenceData: () => {},
	saveFence: false,
	setSaveFence: () => {},
	creating: false,
	setCreating: () => {},
	method: "circle",
	setMethod: () => {},
	activeGeo: null,
	setActiveGeo: () => {},
	geoData: undefined,
	setGeoData: () => {},
	updateGeoData: () => {},
	savePending: false,
	setSavePending: () => {},
	initialGeoData: undefined,
	setInitialGeoData: () => {},
	deleted: false,
	setDeleted: () => {},
	created: false,
	setCreated: () => {},
	hidePolyPart: false,
	setHidePolyPart: () => {},
});

export const useGeofenceContext = () => useContext(GeofenceContext);

export const GeofenceProvider = ({ children }) => {
	const [initialData, setInitialData] = useState(null);
	const [fenceData, setFenceData] = useState(null);
	const [creating, setCreating] = useState(false);
	const [method, setMethod] = useState("circle");
	const [saveFence, setSaveFence] = useState(false)
	const [geofenceDeleted, setGeofenceDeleted] = useState(false);



	return (
		<GeofenceContext.Provider
			value={{
				initialData,
				setInitialData,
				fenceData,
				setFenceData,
				saveFence,
				setSaveFence,
				creating,
				setCreating,
				method,
				setMethod,
				geofenceDeleted,
				setGeofenceDeleted
			}}
		>
			{children}
		</GeofenceContext.Provider>
	);
};
